import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import {
    DataGrid,
    GridColDef,
    GridToolbar,
    // GridColumnVisibilityModel,
    // GridColTypeDef,
    GridValueFormatterParams
} from "@mui/x-data-grid";
import { Box, Button, Typography } from "@mui/material";
import { staff } from "../common/type";
import ClipLoader from "react-spinners/ClipLoader";
import { getStaffs } from "../services/get.service";
import { Link } from "react-router-dom";

const Staffs = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false)
    const [rows, setRows] = useState<Array<staff>>([])

    useEffect(() => {
        setLoading(true);

        getStaffs()
            .then((res) => {
                setLoading(false);
                setRows(res.data)
            })
            .catch((err) => {
                setLoading(false)
                console.log(err)
            })
    }, [setRows]);

    const columns: GridColDef[] = [
        { field: 'firstName', headerName: "First Name", width: 170 },
        { field: 'middleName', headerName: "Middle Name", width: 170 },
        { field: 'lastName', headerName: "Last Name", width: 170 },
        {
            field: 'createdAt', headerName: "Registered Date", width: 170, type: "dateTime", valueFormatter: (val: GridValueFormatterParams<Date>) => {
                return new Date(val.value).toDateString()
            }
        },
        { field: 'phoneNumber', headerName: "Phone Number", width: 170 },
        { field: 'ownerId', headerName: "Meleyo", width: 170 },
    ]

    return <>
        <Helmet>
            <title>{t("Staffs")}</title>
        </Helmet>
        <div className="dark:text-black w-full">
            <div className="lg:m-12 m-4">
                <div className="bg-amber50 shadow-md rounded w-full px-3 lg:px-20 py-10 pt-5">
                    <Button variant="contained"><Link to="/create/staff">Add New</Link></Button>
                    <Typography variant="h4" fontSize={32} className="py-3">Staffs</Typography>
                    <Box sx={{ height: 520, width: "100%" }}>
                        {loading ?
                            (
                                <ClipLoader loading={loading} size={70} />
                            )
                            :
                            (
                                rows !== undefined && rows.length > 0 ?
                                    (
                                        <DataGrid rows={rows} onRowClick={(r) => console.log(r.id)
                                        } columns={columns} slots={{ toolbar: GridToolbar }} />
                                    )
                                    :
                                    <DataGrid rows={[]} columns={columns} />
                            )
                        }
                    </Box>
                </div>
            </div>
        </div>
    </>;
};

export default Staffs;
